import { GamepadCircleDownIcon } from './GamepadCircleDownIcon';

/**
 * author: Haley Halcyon
 * id A7E881F0-76BD-4711-A238-5ECAEA02EAFC
 * name gamepad-circle-down
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-circle-down.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerCircleDownIcon = GamepadCircleDownIcon;
export default ControllerCircleDownIcon